export const construirUrlS3 = (bucket_s3, key_s3) => {
  if (!bucket_s3 || !key_s3) return "";
  const keyCodificado = key_s3.split("/").map(encodeURIComponent).join("/");
  return `https://${bucket_s3}.s3.amazonaws.com/${keyCodificado}`;
};

export const handleSoloLetrasNumeros = (event, setField, long = null) => {
  if (event.target.value != null && event.target.value != undefined) {
    if (event.target.value.length <= long || long == null) {
      const result = event.target.value.replace(/[^0-9a-zA-Z]+$/gi, "");

      setField(result);
    }
  }
};

// export const desencriptarToken = (pass) => {

//   // Decrypt
//   var bytes = CryptoJS.AES.decrypt(token, `${keyPassLogin}`);
//   var originalText = bytes.toString(CryptoJS.enc.Utf8);

//   return originalText;
// };